// extracted by mini-css-extract-plugin
export var documentation = "_jd-1";
export var menu = "_jd-0";